export class ProfitSummary {
    net: number;
    tax: number;
    gross: number;
    margin: number;
    netProfit: number;

    constructor(ProfitSummary: any) {
        Object.assign(this, ProfitSummary);
    }

    UpdateNetProfit() {
        this.netProfit = (this.net * this.margin) / 100;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounting/shared/models/profit-summary.ts